import React from "react";
import { Link } from "react-router-dom";

const Dropdown = ({shopCategories}) => {
  return (
    <div className="grid grid-cols-3 rounded-lg bg-black/50 text-white w-[450px] gap-8 p-4 absolute top-10 left-[-50%] z-10">
      {shopCategories.map((category, index) => (
        <div key={index}>
          <h1 className="text-lg font-semibold mb-2">{category.title}</h1>
          {category.links.map((link, idx) => (
            <Link key={idx} className="block text-white hover:text-blue-400 hover:underline mb-1">
              {link}
            </Link>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Dropdown;
